<template>
  <v-container>
    <h1>Add reference genomes</h1>
    <!-- part to add new genomes from file -->
    <file-upload-field
      label=""
      button-label="Add reference genomes from file"
      @load="loadGenomesFromFile"
    ></file-upload-field>
    <v-alert
      v-for="(item, index) in a_fileErrors"
      :key="index"
      v-model="item.display"
      dismissible
      type="error"
      >{{ item.message }}
    </v-alert>

    <!-- part to add a new genome -->
    <genome-field v-model="a_genomes"></genome-field>

    <!-- parto to display the genomes -->
    <v-card flat>
      <v-card-title>
        <v-layout row>
          <v-flex md3>
            <div class="grey--text">id</div>
          </v-flex>
          <v-flex md4>
            <div class="grey--text">genome url</div>
          </v-flex>
          <v-flex md4>
            <div class="grey--text">gff3</div>
          </v-flex>
        </v-layout>
      </v-card-title>

      <template v-for="(genome, index) in a_genomes">
        <v-layout :key="genome.id" row wrap class="mx-2" align-center>
          <v-flex md3>
            <div>{{ genome.id }}</div>
          </v-flex>
          <v-flex md4>
            <label>{{ genome.fasta }}</label>
          </v-flex>
          <v-flex md4>
            <div>{{ genome.gff3 }}</div>
          </v-flex>
          <v-flex md1 class="text-lg-right">
            <v-btn outline fab small color="indigo" @click="removeGenome(genome)">
              <v-icon dark>remove</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-divider :key="`divider-${index}`"></v-divider>
      </template>
    </v-card>
  </v-container>
</template>

<script>
import GenomeField from './fields/GenomeField.vue';
import FileUploadField from './fields/upload/FileGetContentField.vue';

export default {
  components: {
    GenomeField,
    FileUploadField,
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      a_genomes: this.value,
      a_fileErrors: [],
    };
  },
  methods: {
    removeGenome(g) {
      const genomesFiltered = this.a_genomes.filter(a => a !== g);
      this.a_genomes.splice(0);
      this.a_genomes.push(...genomesFiltered);
    },
    loadGenomesFromFile(text) {
      const lines = text.split('\n');

      // Equivalent to this.a_fileErrors = [] but this way is reactive:
      this.a_fileErrors.splice(0, this.a_fileErrors.length);
      this.a_genomes.splice(0, this.a_genomes.length);

      for (let i = 0; i < lines.length - 1; i += 1) {
        const nbLine = i + 1;
        const line = lines[i];

        const cols = line.split('\t');

        if (cols.length !== 3) {
          const error = {
            message: `\nError when reading file: the line ${nbLine} does not have 3 columns`,
            display: true,
          };
          this.a_fileErrors.push(error);
        } else {
          const genome = {
            id: cols[0].trim(),
            fasta: cols[1].trim(),
            gff3: cols[2].trim(),
          };

          const checkFlag = this.checkGenomeInfo(genome);
          if (checkFlag === true) {
            this.a_genomes.push(genome);
          } else {
            const error = {
              message: `\nError when reading file, line ${nbLine}: ${checkFlag}`,
              display: true,
            };
            this.a_fileErrors.push(error);
          }
        }
      }
    },
    checkGenomeInfo(genome) {
      if (!('id' in genome) || !('fasta' in genome) || !('gff3' in genome)) {
        return 'Error genome info object must contain id, fasta, and gff3 keys';
      }
      const checkId = this.checkId(genome.id);

      const checkFastaUrl = this.checkUrl(genome.fasta);

      const checkGff3Url = this.checkUrl(genome.gff3);

      const check = checkId === true && checkFastaUrl === true && checkGff3Url === true;

      if (check !== true) {
        return (
          (checkId === true ? '' : checkId) +
          (checkFastaUrl === true ? '' : checkFastaUrl) +
          (checkGff3Url === true ? '' : checkGff3Url)
        );
      }

      return true;
    },
    checkId(id) {
      const pattern = /^([0-9a-zA-Z\-_])+$/;
      return (
        pattern.test(id) ||
        'Invalid identifier. Can not be empty and the only allowed characters are [0-9a-zA-Z-_].'
      );
    },
    checkUrl(url) {
      const pattern = /^(http[^\s]+)*$/;
      return pattern.test(url) || 'Invalid URL. Should starts by "http", space not allowed';
    },
  },
};
</script>
